import { z } from 'zod';

const moneyRegex = /^\d+(\.\d{1,2})?$/;

export const CreateCatalogoDtoSchema = z.object({
  key: z.string().min(1),
  value: z.string().min(1),
  category: z.string().min(1),
  active: z.boolean().optional(),
});

export type CreateCatalogoDto = z.infer<typeof CreateCatalogoDtoSchema>;

export const UpdateCatalogoDtoSchema = z.object({
  key: z.string().optional(),
  value: z.string().optional(),
  category: z.string().optional(),
  active: z.boolean().optional(),
});

export type UpdateCatalogoDto = z.infer<typeof UpdateCatalogoDtoSchema>;

export const QueryCatalogosDtoSchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
  // Límite 1000: el catálogo MUNICIPIO tiene ~340 entradas y la cascada
  // departamento → municipio se resuelve client-side.
  limit: z.coerce.number().int().min(1).max(1000).default(20),
  search: z.string().optional(),
  category: z.string().optional(),
});

export type QueryCatalogosDto = z.infer<typeof QueryCatalogosDtoSchema>;

export const CreatePlanDtoSchema = z.object({
  nombre: z.string().min(1),
  precio: z
    .string()
    .regex(moneyRegex, 'precio must be a valid money value (max 2 decimals)')
    .optional(),
  comision: z
    .string()
    .regex(moneyRegex, 'comision must be a valid money value (max 2 decimals)')
    .optional(),
  generaComision: z.boolean().optional(),
  comentarios: z.string().optional(),
});

export type CreatePlanDto = z.infer<typeof CreatePlanDtoSchema>;

export const UpdatePlanDtoSchema = z.object({
  nombre: z.string().optional(),
  precio: z
    .string()
    .regex(moneyRegex, 'precio must be a valid money value (max 2 decimals)')
    .optional(),
  comision: z
    .string()
    .regex(moneyRegex, 'comision must be a valid money value (max 2 decimals)')
    .optional(),
  generaComision: z.boolean().optional(),
  comentarios: z.string().optional(),
});

export type UpdatePlanDto = z.infer<typeof UpdatePlanDtoSchema>;

export const QueryPlanesDtoSchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  search: z.string().optional(),
});

export type QueryPlanesDto = z.infer<typeof QueryPlanesDtoSchema>;

export const CreateTipoServicioDtoSchema = z.object({
  nombre: z.string().min(1),
  generaCobro: z.boolean().optional(),
});

export type CreateTipoServicioDto = z.infer<typeof CreateTipoServicioDtoSchema>;

export const UpdateTipoServicioDtoSchema = z.object({
  nombre: z.string().optional(),
  generaCobro: z.boolean().optional(),
});

export type UpdateTipoServicioDto = z.infer<typeof UpdateTipoServicioDtoSchema>;

export const QueryTiposServicioDtoSchema = z.object({
  offset: z.coerce.number().int().min(0).default(0),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  search: z.string().optional(),
});

export type QueryTiposServicioDto = z.infer<typeof QueryTiposServicioDtoSchema>;
